"use client"

import { useState, useContext, useEffect } from "react"
import { ErpContext } from "../../context/ErpContext.js"
import {
  TextField,
  Button,
  Container,
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Tabs,
  Tab,
  Paper,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
} from "@mui/material"
import {
  Person as PersonIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  LocationOn as LocationIcon,
  Badge as BadgeIcon,
  Business as BusinessIcon,
  Add as AddIcon,
  List as ListIcon,
} from "@mui/icons-material"
import TablaEntidadComponent from "./TablaEntidadComponent.js"
import FormularioEntidadComponent from "./FormularioEntidadComponent.js"
import Swal from "sweetalert2"
import withReactContent from "sweetalert2-react-content"

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  )
}

const GestionEntidadComponent = () => {
  const { tipoEntidades, getTipoEntidad, postEntidad, condicionIva, getCondicionIva, isNavbarCollapsed } = useContext(ErpContext)

  const [descripcionEntidad, setDescripcionEntidad] = useState("")
  const [apellidoEntidad, setApellidoEntidad] = useState("")
  const [telefonoEntidad, setTelefonoEntidad] = useState("")
  const [emailEntidad, setEmailEntidad] = useState("")
  const [dniCuitCuilEntidad, setdniCuitCuilEntidad] = useState("")
  const [direccionEntidad, setDireccionEntidad] = useState("")
  const [localidadEntidad, setLocalidadEntidad] = useState("")
  const [provinciaEntidad, setProvinciaEntidad] = useState("")
  const [idTipoEntidadEntidad, setIdTipoEntidadEntidad] = useState("")
  const [idCondicionIvaEntidad, setIdCondicionIvaEntidad] = useState("")

  const [tabValue, setTabValue] = useState(0)
  const [showSuccess, setShowSuccess] = useState(false)
  const [errors, setErrors] = useState({})

  useEffect(() => {
    getTipoEntidad()
    getCondicionIva()
  }, [])

  const validateForm = () => {
    const newErrors = {}

    if (!descripcionEntidad.trim()) {
      newErrors.descripcion = "El nombre es requerido"
    }

    if (!dniCuitCuilEntidad.trim()) {
      newErrors.dniCuitCuil = "El DNI/CUIT/CUIL es requerido"
    }

    if (emailEntidad && !/\S+@\S+\.\S+/.test(emailEntidad)) {
      newErrors.email = "Email inválido"
    }

    if (!idTipoEntidadEntidad) {
      newErrors.idTipoEntidad = "Debe seleccionar un tipo de entidad"
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const resetForm = () => {
    setDescripcionEntidad("")
    setApellidoEntidad("")
    setTelefonoEntidad("")
    setEmailEntidad("")
    setdniCuitCuilEntidad("")
    setDireccionEntidad("")
    setLocalidadEntidad("")
    setProvinciaEntidad("")
    setIdTipoEntidadEntidad("")
    setIdCondicionIvaEntidad("")
    setErrors({})
  }

  const handleEntidadSubmit = async (e) => {
    e.preventDefault()

    if (!validateForm()) {
      return
    }

    try {
      await postEntidad(
        descripcionEntidad,
        apellidoEntidad,
        telefonoEntidad,
        emailEntidad,
        dniCuitCuilEntidad,
        direccionEntidad,
        localidadEntidad,
        provinciaEntidad,
        idTipoEntidadEntidad,
        idCondicionIvaEntidad,
      )

      resetForm()
      setShowSuccess(true)
      setTimeout(() => setShowSuccess(false), 3000)
      SucessModal()
    } catch (error) {
      ErrorModal()
    }
  }

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue)
  }

  const ErrorModal = () => {
    withReactContent(Swal).fire({
      position: "bottom-end",
      icon: "error",
      text: "Error en CREAR la entidad",
      showConfirmButton: false,
      timer: 3000,
      width: 300,
    })
  }

  const SucessModal = () => {
    withReactContent(Swal).fire({
      position: "bottom-end",
      icon: "success",
      text: "Se CREO la entidad correctamente",
      showConfirmButton: false,
      timer: 3000,
      width: 300,
    })
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 2 }}>
      <Paper elevation={0} sx={{ borderRadius: 2, overflow: "hidden" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider", bgcolor: "#f8f9fa" }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            sx={{
              "& .MuiTab-root": {
                color: "#5b5b5f",
                fontWeight: 600,
                textTransform: "none",
                fontSize: "16px",
                minHeight: "60px",
                "&.Mui-selected": {
                  color: "#5b5b5f",
                },
              },
              "& .MuiTabs-indicator": {
                backgroundColor: "#5b5b5f",
                height: 3,
              },
            }}
          >
            <Tab icon={<AddIcon />} label="Crear Entidad" iconPosition="start" sx={{ mr: 2 }} />
            <Tab icon={<ListIcon />} label="Gestionar Entidades" iconPosition="start" />
          </Tabs>
        </Box>

        <TabPanel value={tabValue} index={0}>
          <Card elevation={2} sx={{ borderRadius: 2 }}>
            <CardContent sx={{ p: 4 }}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
                <BusinessIcon sx={{ color: "#5b5b5f", mr: 2, fontSize: 28 }} />
                <Typography variant="h5" sx={{ color: "#5b5b5f", fontWeight: 600 }}>
                  Nueva Entidad
                </Typography>
              </Box>

              {showSuccess && (
                <Alert severity="success" sx={{ mb: 3, borderRadius: 2 }}>
                  ¡Entidad creada exitosamente!
                </Alert>
              )}

              <form onSubmit={handleEntidadSubmit}>
                <FormularioEntidadComponent
                  descripcionEntidad={descripcionEntidad}
                  setDescripcionEntidad={setDescripcionEntidad}
                  apellidoEntidad={apellidoEntidad}
                  setApellidoEntidad={setApellidoEntidad}
                  dniCuitCuilEntidad={dniCuitCuilEntidad}
                  setdniCuitCuilEntidad={setdniCuitCuilEntidad}
                  telefonoEntidad={telefonoEntidad}
                  setTelefonoEntidad={setTelefonoEntidad}
                  emailEntidad={emailEntidad}
                  setEmailEntidad={setEmailEntidad}
                  direccionEntidad={direccionEntidad}
                  setDireccionEntidad={setDireccionEntidad}
                  localidadEntidad={localidadEntidad}
                  setLocalidadEntidad={setLocalidadEntidad}
                  provinciaEntidad={provinciaEntidad}
                  setProvinciaEntidad={setProvinciaEntidad}
                  idTipoEntidadEntidad={idTipoEntidadEntidad}
                  setIdTipoEntidadEntidad={setIdTipoEntidadEntidad}
                  idCondicionIvaEntidad={idCondicionIvaEntidad}
                  setIdCondicionIvaEntidad={setIdCondicionIvaEntidad}
                  tipoEntidades={tipoEntidades}
                  condicionIva={condicionIva}
                  errors={errors}
                  showCondicionIva={true}
                  compact={false}
                />

                <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 3 }}>
                  <Button
                    variant="outlined"
                    onClick={resetForm}
                    sx={{
                      borderColor: "#5b5b5f",
                      color: "#5b5b5f",
                      "&:hover": {
                        borderColor: "#5b5b5f",
                        backgroundColor: "rgba(91, 91, 95, 0.04)",
                      },
                    }}
                  >
                    Limpiar
                  </Button>
                  <Button
                    variant="contained"
                    type="submit"
                    startIcon={<AddIcon />}
                    sx={{
                      backgroundColor: "#5b5b5f",
                      "&:hover": {
                        backgroundColor: "#4a4a4e",
                      },
                      px: 4,
                    }}
                  >
                    Crear Entidad
                  </Button>
                </Box>
              </form>
            </CardContent>
          </Card>
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <TablaEntidadComponent />
        </TabPanel>
      </Paper>
    </Container>
  )
}

export default GestionEntidadComponent
